import { useStore } from 'effector-react'
import { RentalContractStatusEnum } from '~/shared/config/enums'
import { $rentalContract } from './model'

export const useRentalContractStatus = () => {
  const rentalContract = useStore($rentalContract)
  const status = rentalContract?.getStatus()

  const isActive = status === RentalContractStatusEnum.ACTIVE
  const isSigning = status === RentalContractStatusEnum.SIGNING
  const isSigned = status === RentalContractStatusEnum.SIGNED
  const isCancellationInProgress =
    status === RentalContractStatusEnum.CANCELLATION_IN_PROGRESS
  const isSuspended = status === RentalContractStatusEnum.SUSPENDED

  return {
    isActive,
    isSigning,
    isSigned,
    isCancellationInProgress,
    isSuspended,
  }
}
